import React from "react";

const NewTag = ({ className = "" }) => {
    return (
        <span
            className={`inline-flex items-center px-2 py-1 rounded-[1vw] text-xs font-bold text-white bg-gradient-to-r from-red-500 to-pink-500 shadow-sm ${className}`}
        >
            NEW
        </span>
    );
};

export default NewTag;
